/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupTaskTypes } from '@veeam-vspc/models/web-controllers';

import { core } from 'core/core-module';
import { transformBaseChartData } from 'views/pages/TrendsPage/helpers';

import type { BaseDataResponse } from 'core/services/transport/interfaces/base-data-response';
import type { LineChartData, TrendData } from '../../../../../interfaces';

const names = [
    { label: 'Ratio', type: BackupTaskTypes.BackupTask },
];

export class BackupTasksRatioService {
    static fetchData({ reportingPeriodInfo }): Promise<LineChartData> {
        return core.transportService
            .request('Trends/SuccessfulBackup', { ...reportingPeriodInfo })
            .then((resp: BaseDataResponse<TrendData>) => {
                resp.data.trends.forEach(trend => trend.counters.forEach((c) => {
                    c.value = c.value === null ? null : Math.round(c.value);
                }));

                return transformBaseChartData(resp.data.trends, reportingPeriodInfo, names);
            });
    }
}
